import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SpecLineModel} from "../../../properties/models/spec-line.model";
import {ClassificatorValuesQuery, CONSTANTS, LeModalService, PropertiesQuery} from "common-shared";
import {ExpressionFormulaEditorComponent} from "../../property-mappings/expression-formula-editor/expression-formula-editor.component";

@Component({
  selector: 'web-spec-value',
  templateUrl: './spec-value.component.html',
  styles: []
})
export class SpecValueComponent implements OnInit {
  @Input() spec: SpecLineModel;
  @Input() readonly: boolean = false;
  @Input() showLabel: boolean = false;
  @Input() isInvalid: boolean = false;
  @Input() initOpened: boolean = false;
  @Input() labelCss: string = '';
  Classificators = CONSTANTS;
  @Output() changed = new EventEmitter<SpecLineModel>();
  @Output() edit = new EventEmitter<SpecLineModel>();

  constructor(public propertiesQuery: PropertiesQuery, public classificatorValuesQuery: ClassificatorValuesQuery, private leModalService: LeModalService) {
  }

  ngOnInit() {
  }

  onChanged() {
    this.changed.emit(this.spec);
  }

  onMultiChoiceChanged(line: SpecLineModel, $event: string[]) {
    line.Value = JSON.stringify($event);
  }

  onNumericChanged(line: SpecLineModel, $event: number[] | number, isMultiChoice: boolean) {
    if (isMultiChoice) {
      line.Value = JSON.stringify(($event as number[]).map(value => Number(value)));
    } else {
      line.NumericValue = $event as number;
    }
    this.onChanged();
  }

  onTextChanged(line: SpecLineModel, $event: string[] | string, isMultiChoice: boolean) {
    if (isMultiChoice) {
      line.Value = JSON.stringify([...$event]);
    } else {
      line.Value = $event as string;
    }
    this.onChanged();
  }

  addNumericValue(value: string) {
    value = value.replace(',','.');
    return {Value: value, Key: value};
  }

  addTextValue(value: string) {
    return {Value: value, Key: value};
  }

  showTrace() {
    this.leModalService.show(ExpressionFormulaEditorComponent, {class: 'modal-lg', initialState: {expression: this.spec.Trace, hasExternalFormula: false, readonly: true}})
  }
}
